<template>
  <div class="history">
    <div class="title">
      <div class="btns">
        <button
          @click="changeTable(true)"
          :disabled="isActive"
          :class="{ 'active-span': isActive }"
          class="activeorders"
        >
          سفارشات فعال
        </button>
        <button
          @click="changeTable(false)"
          :disabled="!isActive"
          :class="{ 'active-span': !isActive }"
          class="tradehistory"
        >
          تاریخچه سفارشات
        </button>
        <div :class="!isActive ? 'ot' : 'ao'" class="underline"></div>
      </div>
    </div>
    <div class="table">
      <template v-if="filterTable.length > 0">
        <perfect-scrollbar>
          <table>
            <tr class="thead">
              <td class="remove">زمان</td>
              <td>معامله</td>
              <td>مقدار</td>
              <td class="remove">مجموع ({{ $coins[tradeTo].persianName }})</td>
              <td>قیمت ({{ $coins[tradeTo].persianName }})</td>
              <td v-if="isActive">انجام شده</td>
              <td>{{ !isActive ? "وضعیت" : "عملیات" }}</td>
            </tr>
            <tr class="tbody" v-for="(item, index) in filterTable" :key="index">
              <td class="remove">{{ $G2J(item.createdAtDateTime) }}</td>
              <td :class="item.orderType.includes('BUY') ? 'success' : 'fail'">
                {{ $orderType[item.orderType] }}
              </td>
              <td>
                {{ $toLocal(item.amount, $coins[tradeFrom].precision) }}
              </td>
              <td class="remove">
                {{ $toLocal(item.overallValue, $coins[tradeTo].precision) }}
              </td>
              <td>
                {{ $toLocal(item.unitPrice, $coins[tradeTo].precision) }}
              </td>
              <td v-if="isActive">{{ item.executedPercent }}%</td>
              <td
                class="success"
                v-if="!isActive && item.orderStatus.includes('FINISHED')"
              >
                موفق
              </td>
              <td
                class="fail"
                v-if="!isActive && item.orderStatus.includes('CANCELLED')"
              >
                لغو شده
              </td>
              <td v-if="isActive" @click="candelOrder(item.id)" class="td-btn">
                لغو سفارش
              </td>
            </tr>
          </table>
        </perfect-scrollbar>
      </template>
      <template v-else>
        <div class="no-content">
          <span> محتوایی جهت نمایش وجود ندارد </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { tradeTo, tradeFrom, Loop } from "@/library/reuseableFunction";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
export default {
  name: "HistoryP2P",
  component: {
    PerfectScrollbar,
  },
  data() {
    return {
      isActive: false,
      activeOrders: [],
      tradeHistory: [],
      loop: undefined,
    };
  },
  computed: {
    filterTable() {
      let data;
      if (!this.isActive) {
        data = this.tradeHistory;
      } else {
        data = this.activeOrders;
      }
      return data;
    },
    tradeTo,
    tradeFrom,
  },
  methods: {
    changeTable(val) {
      this.isActive = val;
      this.activeOrders = [];
      this.tradeHistory = [];
      this.getOrders();
    },
    async getOrders() {
      if (this.state.userInfo.authorized) {
        const res = await this.$axios.get("/orders", {
          params: {
            market: this.tradeFrom + "_" + this.tradeTo,
            orderStatus: this.isActive ? "IS_OPEN" : null,
            size: 20,
          },
        });
        if (this.isActive) {
          this.activeOrders = res.content;
        } else {
          this.tradeHistory = res.content.filter(
            (a) => a.orderStatus !== "IS_OPEN"
          );
        }
      }
    },
    async candelOrder(e) {
      this.$swal
        .fire({
          title: "لغو سفارش",
          text: "سفارش شما لغو خواهد شد و قابل برگشت نخواهد بود ",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: "بازگشت",
          confirmButtonText: "لفو سفارش",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.state.loading = true;
            const [res] = await this.$http.delete(`orders/${e}`);
            if (res) {
              ++this.state.orderChanged;
              this.getOrders();
              this.$swal.fire(
                "لغو سفارش",
                "سفارش شما با موفقیت لغو شد",
                "success"
              );
            }
          }
        });
    },
  },
  async mounted() {
    if (this.state.token && this.state.userInfo.authorized) {
      this.state.loading = true;
      this.loop = new Loop(this.getOrders, 5000, "lastOrder");
      if (this.state.loop) {
        this.loop.start();
      } else {
        this.getOrders();
      }
    }
  },
  beforeDestroy() {
    this.loop.stop();
  },
};
</script>

<style lang="scss" scoped>
.no-content {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
  padding-top: 30px;
  span {
    font-size: clamp(14px, 1vw, 16px);
    font-weight: 400;
    color: var(--grey);
  }
}
.activeorders,
.tradehistory {
  cursor: pointer;
}
.thead {
  font-size: clamp(11px, 1vw, 13px);
  font-weight: 400;
  color: var(--grey);
  position: sticky;
  top: 0;
  background: var(--box);
}
.tbody {
  font-size: clamp(11px, 1vw, 13px);
  font-weight: 400;
  color: var(--grey);
}
.td-btn {
  opacity: 0.5;
  cursor: pointer;
  &:hover {
    opacity: 1;
    color: var(--red);
  }
}
.table {
  background: var(--box);
  width: 100%;
  height: 100%;
  overflow: scroll;
  table {
    border-collapse: collapse;
    width: 100%;
    text-align: center;
  }
  tr {
    height: 37px;
    border-bottom: 1px solid var(--light-grey);
  }
}
.ot {
  left: 0px;
}
.ao {
  right: 0px;
  width: 80px !important;
}
.underline {
  width: 89px;
  height: 3px;
  border-radius: 4px;
  background: var(--primary-color);
  position: absolute;
  bottom: -4px;
}
.history {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 15%;
  max-height: 300px;
  .title {
    width: 100%;
    border-radius: 4px 4px 0px 0px;
    background: var(--light-grey);
    padding: 5px 12px;
    .btns {
      display: flex;
      flex-direction: row;
      column-gap: 39px;
      position: relative;
      // justify-content: space-between;
      width: max-content;
      button {
        cursor: pointer;
        color: var(--grey);
        font-size: clamp(12px, 1vw, 14px);
        font-weight: 400;
        opacity: 1;
        background-color: transparent !important;
        &:hover {
          opacity: 1 !important;
        }
      }
    }
  }
}
@media only screen and (max-width: 700px) {
  .remove {
    display: none;
  }
}
</style>
